export default __webpack_public_path__ + "static/media/martin_mcKenna.abace93d.png";